import 'swiper/css';
import 'swiper/css/navigation';

import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslations } from 'next-intl';
import { FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useTopTeachers } from 'modules/courses/hooks';
import { setType } from 'modules/courses/store';
import { globalConst, isEmptyArr } from 'modules/global';

import { EmptyData, Visible } from 'components';

import SectionWrapper from '../section-wrapper';
import TeacherCard from '../teacher-card';
import TeacherSkeleton from '../teacher-skeleton';

const TopTeachers = () => {
  const t = useTranslations();
  const { topTeachers, isLoading } = useTopTeachers();
  const dispatch = useDispatch();

  const onChangeType = () => {
    dispatch(setType('teachers'));
  };

  return (
    <SectionWrapper onChange={onChangeType} title={t("top_oqituvchilar")} path={globalConst.pageNames.COURSES_FILTER}>
      <Visible
        if={isLoading}
        else={
          <Visible
            if={isEmptyArr(topTeachers)}
            else={
              <Swiper slidesPerView="auto" modules={[FreeMode]} freeMode spaceBetween={9}>
                {topTeachers?.map(teacher => (
                  <SwiperSlide key={teacher?.id} className="min-w-40 max-w-40">
                    <TeacherCard
                      key={teacher?.id}
                      image={teacher?.image?.small}
                      name={teacher?.full_name}
                      specialty={teacher?.user_name}
                      url={teacher?.slug}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            }
          >
            <EmptyData title={t('malumot_topilmadi')} />
          </Visible>
        }
      >
        <div className="grid grid-cols-6 gap-3">
          {Array.from({ length: 6 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <TeacherSkeleton key={index} />
          ))}
        </div>
      </Visible>
    </SectionWrapper>
  );
};

export default TopTeachers;
